module.exports = __webpack_public_path__ + "media/images/product_owners/navair_90-13d46a938644111ffb03e4660453e942.png";